/*
 * @Description: 温馨提示文本
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-08-10 17:09:00
 * @LastEditors: situgen@szkingdom.com
 */
import cache from "../assets/js/cache";
import constant from "../constant";

const warningHtml = {
    warningHtml: `定期定额申购协议开通后，请在扣款日前一天确保账户金额充足，如遇金额不足，我们会在下个工作日为您补扣一次。新开户用户，如果您的基金账户开立不成功，相应的定期定额协议也将失败。`,
    warningHtml1: `<p>1.亲爱的中银易商用户，请下载${
        constant.COMPANY
    }基金APP完成相关操作，官网、微信不支持该项目服务，给您带来的不便深表歉意。您可以拨打${
        constant.COMPANY
    }基金客服热线  <span style="color:red;">${cache.getCompanyInfoParam(
        "10101009"
    )}</span>  进行咨询。</p>
                        <p class="mt5">2.如果您的支付银行卡为民生银行，无法自助找回交易密码，请联系客服  <span style="color:red;">${cache.getCompanyInfoParam(
                            "10101009"
                        )}</span>找回。</p>`,
    warningHtml2: `1.亲爱的中银易商用户，请下载${
        constant.COMPANY
    }基金APP完成相关操作，官网、微信不支持该项服务，给您带来的不便深表歉意。您可以拨打${
        constant.COMPANY
    }基金客服热线进行咨询：${cache.getCompanyInfoParam("10101009")}`,
    warningHtml3:
        "<p>1.签约代扣协议后，您可轻松进行基金定投,并可更快速完成基金购买流程；</p><p>2.您绑定的农行卡可以直接在此板块完成签约或解约，部分银行为默认开通，不能解约。</p>",
    warningHtml4: `1.${constant.getXJBParam(
        "sname"
    )}买基金”实质为基金转换交易（适用于已开通转换业务的基金）或赎回转认/申购交易（适用于未开通转换业务的基金）等业务。通过“${constant.getXJBParam(
        "sname"
    )}买基金”功能，可享手续费率优惠。最低10元起购。<br>2.${
        constant.COMPANY
    }基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。`,
    warningHtml5: "1.货币基金分红方式默认为红利再投，不能修改。",
    warningHtml6:
        "1.本计算结果仅供参考，并不预示基金将来的收益。投资者不应以网络提供的数据作为基金投资标准。<br>2、基金不对计算结果的准确性及完整性负责，也不对使用计算结果引起的后果负任何责任。",
    warningHtml7: `1.${constant.getXJBParam(
        "sname"
    )}买基金”实质为基金转换交易（适用于已开通转换业务的基金）或赎回转认/申购交易（适用于未开通转换业务的基金）等业务。通过“${constant.getXJBParam(
        "sname"
    )}买基金”功能，可享手续费率优惠。最低10元起购。<br>2.基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。`,
    warningHtml8: `1.如果您是从中银易商渠道转来的客户，可下载基金APP完成相关操作，官网不支持该项服务。给您带来的不便深表歉意。如有疑问可拨打基金客服热线进行咨询：${cache.getCompanyInfoParam(
        "10101009"
    )}。<br>2.基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。<br> 3.您最终申请提交时间以我公司注册登记中心接收时间为准。`,
    warningHtml9:
        "1.基金交易崇尚长期投资，不提倡短线波段操作！<br>2.基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。",
    warningHtml10:
        "1.该业务能实现不能转换或尚未开通转换业务的基金之间的间接转换，操作简单，方便安全！",
    warningHtml11:
        "1.基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。",
    warningHtml12: `1.“自动存入”指的是定期定额申购${constant.getXJBParam(
        "fundname"
    )}（${constant.getXJBParam("fundcode")}），“自动取出“指的是定期定额赎回${constant.getXJBParam(
        "fundname"
    )}（${constant.getXJBParam("fundcode")}）。`,
    warningHtml13:
        "1.普通定投计划，又称'定期定额投资'，通过定期投入固定金额的方法，既有利于资金管理，还能够达到积少成多的效果!",
    warningHtml14:
        "<p>1.上述信息如发生变化，还请及时登录我的账户-账户管理-风险测评进行修改。同时，建议您每半年度定期更新风险测评，以便更好的了解自己的风险承受情况。</p><p>2.我司履行风险承受能力评估等适当性职责，并不能取代您自己的投资判断，也不会降低金融产品或金融服务的固有风险，同时，与金融产品或金融服务相关的投资风险、履行责任以及费用等将由您自己承担。</p><p>3.投资者所提供的的相关信息及证明材料应当真实、准确完整。投资者不提供信息或提供的信息、资料不真实、不准确、不完整，我司无法准确确定投资者的风险承受能力等级，由此产生的后果由投资者自行承担。投资者购买产品或接收服务时，法律法规、自律规则规定的投资者准入要求相关信息不完整的，基金公司应当拒绝向投资者销售产品或者提供服务。</p>",
    warningHtml15:
        "<p>1.标准申购费率高于0.6%的基金，针对不同银行设有不同的申购优惠费率，但折后不得低于0.6%；标准申购费率低于0.6%的基金，按原费率执行。</p><p>2.投资者在点击“立即去银行支付”后，会出现“用相同会话号进行交易，请关闭本窗口继续交易！如原窗口已经关闭，则登录登出网页清除原登录信息！”的提示信息。此时请勿关闭浏览窗口，并点击“登录登出网页清除原登录信息！”，之后返回基金网上交易系统，重新点击“立即去银行支付”。<p>",
    warningHtml16:
        "1.智能定投计划，又称“定期不定额投资”，可自动实现“低位多投、高位少投”的定投策略。让您的定投平均成本更低、盈率更高。"
};
export default warningHtml;
